import { Chip, Link } from "@mui/material"
import _ from "lodash"
import colors from "styles/colors"
import texts from "styles/texts"
import AppIcon from "./AppIcon"
import css from "./AppInfoHeader.module.scss"
import { Column, Row } from "./Layout"

const AppInfoHeader = ({
  icon,
  name,
  developer,
  offersIAP = false,
  primaryCategory,
  appOtherCategories,
  tags,
}) => {
  const chips = _.chain([
    primaryCategory.replace("GAME_", ""),
    ...appOtherCategories.map(c => c.replace("GAME_", "")),
    ...tags.map(t => t.label),
  ])
    .map(label => label.toLowerCase())
    .uniq()
    .take(3)
    .value()

  return (
    <Row
      className={css.appInfoHeader}
      align="mc"
      gap="md"
    >
      <AppIcon src={icon} size={70} />

      <Column
        align="sb"
        col={1}
        className={css.info}
        style={{ minWidth: 0, height: 70 }}
      >
        <h3 className="ellipsis">{name}</h3>

        <Row align="ml" gap="xs">
          {chips.map(label => (
            <Chip
              key={label}
              label={label}
              size="small"
              sx={{
                font: texts.ranking,
                textTransform: "capitalize",
                background: colors.cardsBackground,
                color: colors.textMedium,
                height: 18,
              }}
            />
          ))}
        </Row>

        <Row align="ml" gap="xs" style={{ font: texts.ranking, color: colors.textDark, fontSize: '0.75em' }}>
          {developer.name && (
            <Link
              to={`${developer.website}`}
              className="ellipsis"
              style={{
                color: colors.textLight,
                textDecoration: "none",
              }}
            >
              By {developer.name}
            </Link>
          )}
          {offersIAP && (
            <span style={{ whiteSpace: "nowrap" }}>In-app purchases</span>
          )}
        </Row>
      </Column>
    </Row>
  )
}

export default AppInfoHeader
